import ChatHubAlternativePage from '@/components/Pages/ChatHubAlternativePage';

export default ChatHubAlternativePage;
